<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >
    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-download"
            font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>
    <b-card
        title="صورت حساب های کافه بازار"
    >
      <b-row>
        <b-col
            class="table-size"
        >
          <div class="custom-search">
            <b-row>
                <b-col cols="12" class="mb-2">
                  <b-button
                      class="mb-1"
                      variant="primary"
                      @click="show = true"
                  >
                    ورود اطلاعات
                  </b-button>
                  <b-button
                      variant="gradient-secondary"
                      class="mb-1 ml-1"
                      @click="exportExcel()"
                  >خروجی اکسل
                  </b-button>
                </b-col>
                <b-col>
                  <div class="filter-row w-full">
                  <b-col md="2">
                    <b-form-group
                        label="مقدار"
                        label-for="Amount"
                    >
                      <b-form-input
                          v-model="filterOptions.Amount"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="توکن"
                        label-for="Token"
                    >
                      <b-form-input
                          v-model="filterOptions.Token"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="از تاریخ"
                        label-for="FromDate"
                    >
                      <date-picker
                          v-model="filterOptions.FromDate"
                          clearable
                          type="datetime"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY-jMM-jDD HH:mm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="تا تاریخ"
                        label-for="FromDate"
                    >
                      <date-picker
                          v-model="filterOptions.ToDate"
                          clearable
                          type="datetime"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY-jMM-jDD HH:mm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                        label="دارای سفارش"
                        label-for="HaveOrder"
                    >
                      <v-select
                          v-model="filterOptions.HaveOrder"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="Type"
                          :clearable="true"
                          :options=" [
    {
      key: 'ok', text: 'دارد', value: true,
    },
    {
      key: 'cancel', text: 'ندارد', value:false,
    },
  ]"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="1">
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        class="mb-1 mr-1"
                        variant="warning"
                        @click="update(1)"
                    >فیلتر
                    </b-button>
                  </b-col>
                  </div>
                </b-col>
            </b-row>
          </div>
          <b-table
              bordered
              hover
              striped
              :items="items"
              :fields="fields"
              class="mt-1 mb-2 position-relative"
              responsive
              :busy="loading"
          >
            <template #cell(Id)="data">
              <b-link
                  :to="{ name: 'updatebanner', params: { id: data.value }}"
                  class="font-weight-bold"
              >
                #{{ data.value }}
              </b-link>
            </template>
            <template #cell(Amount)="data">
              {{ data.value | price }}
            </template>
            <template #cell(PurchaseTime)="data">
              {{ data.value | date }}
              {{new Date(data.value).toLocaleTimeString('en-GB') | time}}
            </template>
            <template #cell(HaveOrder)="data">
              <b-badge v-if="data.value ===  true" variant="success">بله </b-badge>
              <b-badge v-else variant="warning">خیر</b-badge>
            </template>
            <template #cell(DietOrder)="data">
              <template v-if="data.item.DietOrder">
                <span class="d-inline-block">{{data.item.DietOrder.Name || '--'}}</span>
                <span class="ml-1 d-inline-block">{{data.item.DietOrder.Family || '--' }}</span>
                <p>{{data.item.DietOrder.Mobile}}</p>
                <p>{{data.item.DietOrder.Email}}</p>
              </template>
            </template>

            <template #cell(actions)="data">
              <feather-icon v-if="!data.item.HaveOrder" icon="SettingsIcon" @click="showVerifyOrder=true;form.Id=data.item.Id" />
            </template>
            <template #table-busy>
              <div
                  class="text-center my-2"
              >
                <b-spinner
                    variant="primary"
                    class="align-middle"
                />
                <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
              </div>
            </template>
          </b-table>
          <z-pagination
              :page="filterOptions.Page"
              :total-rows="totalRows"
              :loading="loading"
              @change="update"
          />
        </b-col>
      </b-row>
      <b-modal
          v-model="show"
          centered
          title="ورود اطلاعات"
          :no-close-on-backdrop="true"
          size="md"
          ok-title="ارسال"
          cancel-title="لغو"
          @ok="save"
      >
        <b-overlay :show="loading" rounded spinner-small class="">
          <b-card>
            <b-col md="12">
              <b-form-group
                  label="از تاریخ"
                  label-for="FromDate"
              >
                <date-picker
                    v-model="form.FromDate"
                    clearable
                    type="datetime"
                    format="YYYY-MM-DD HH:mm"
                    display-format="jYYYY-jMM-jDD HH:mm"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="تا تاریخ"
                  label-for="FromDate"
              >
                <date-picker
                    v-model="form.ToDate"
                    clearable
                    type="datetime"
                    format="YYYY-MM-DD HH:mm"
                    display-format="jYYYY-jMM-jDD HH:mm"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="فایل">
                <b-form-file
                    v-model="form.File"
                >
                </b-form-file>
              </b-form-group>
            </b-col>
          </b-card>
        </b-overlay>
      </b-modal>
      <b-modal
          v-model="showVerifyOrder"
          ok-title="ذخیره"
          cancel-title="انصراف"
          cancel-variant="outline-secondary"
          centered
          title="فعال سازی "
          :no-close-on-backdrop="true"
          size="md"
          @ok="saveVerifyOrder"
          @cancel="showVerifyOrder=false;form={}"
          @close="form={}"
      >
        <div>
          <b-row>
            <b-col cols="12">
              <b-form-group >
                <b-form-radio-group
                    id="skin-radio-group"
                    v-model="billType"
                    name="skin"
                    :options="[
    { value: 0, text: 'صورت حساب رژیم' },
    { value: 1, text: 'صورت حساب  ورزش'},
  ]"
                />
              </b-form-group >
            </b-col>
            <b-col>
              <b-form-group v-if="billType===0" label="شناسه رژیم">
                <b-form-input v-model="form.DietOrderId">
                </b-form-input>
              </b-form-group >
 <b-form-group v-else-if="billType===1" label="شناسه حساب ورزش">
                <b-form-input v-model="form.ActivityOrderId">
                </b-form-input>
              </b-form-group>
<b-form-group  label="شماره پرداخت">
                <b-form-input v-model="form.Id" readonly>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col
                class="image"
                cols="12"
            >
              <fm-file-select v-model="form.AttacheFile" label="عکس فیش" :entity="18" />
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </b-card>
  </b-overlay>

</template>

<script>

import ZBannerPosition from '@/tools/bannerposition.vue'
import UploadFile from "@/tools/uploadFile.vue";
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";

export default {
  name: 'cafebazar',
  components: {
    FmFileSelect,
    UploadFile,
    ZBannerPosition,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Page: 1,
        Amount:'',
        Token:'',
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD HH:mm'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD  HH:mm'),
        PerPage : 10
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key:'PhoneEmail',
          label:'تلفن'
        },
         {
          key:'Amount',
          label:'مقدار'
        },
        {
          key:'Token',
          label:'توکن'
        },
        {
          key:'ProductService',
          label:'سرویس محصولات'
        },
            {
          key:'PurchaseTime',
          label:'زمان خرید'
        },
           {
          key:'HaveOrder',
          label:'سفارش دارد'
        },
          {
          key:'DietOrder',
          label:'کاربر'
        },
             {
          key:'DietOrder.DietType',
          label:'محصول'
        },


  {
          key:'ActivityOrder.Title',
          label:'سفارش فعال'
        },
        {
          key: 'actions',
          label: 'فعال سازی',
        },
      ],
      items: [],
      show: false,
      form:{},
      counter:null,
      processing:null,
      showVerifyOrder:false,
      billType:0
    }
  },

  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update(1)
  },
  methods: {
    saveVerifyOrder(){
      this.$http.post(
          this.$api.userdietorder.CafebazarVerify, {
            "Id" : this.form.Id,
            "DietOrderId": this.form.DietOrderId,
            "ActivityOrderId": this.form.ActivityOrderId,
            "AttacheFile" : this.form.AttacheFile
          },
      ).then(()=>{
        this.update()
        this.form={}
      })
    },
    save() {
      let url = this.$api.bill.import
      const formData = new FormData()
      formData.append('FromDate', this.form.FromDate)
      formData.append('ToDate', this.form.ToDate)
      formData.append('File', this.form.File)

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.update(1)
          })
          .finally(() => {
            this.loading = false
          })
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', {
        key: this.$options.name,
        value: this.filterOptions
      })
      this.filterOptions.Token =  this.filterOptions.Token?.length ?this.filterOptions.Token : null
      this.filterOptions.Amount =  this.filterOptions.Amount?.length ?this.filterOptions.Amount : null
      this.$http.post(
         this.$api.bill.getlist,
          this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    exportExcel(){
      var This = this
      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'special-diet-users.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      let url = new URL(window.location.origin + '/api/Cafebazar/excel')
      url.searchParams.set('FromDate', this.$moment(this.filterOptions.FromDate).format('YYYY-MM-DD'));
      url.searchParams.set('ToDate', this.$moment(this.filterOptions.ToDate).format('YYYY-MM-DD'));
      if (this.filterOptions.DietDurationId) url.searchParams.set('DietDurationId', this.filterOptions.DietDurationId);
      xmlHttpRequest.open("POST", url)
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send()
    }
  },
}
</script>
